import GATSBY_COMPILED_MDX from "/vercel/path0/content/documentation/workflows/triggers/on-inactivity.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import SEO from '../components/SEO';
import Aside from '../components/AsideMdx';
import WasThisHelpful from '../components/WasThisHelpful';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import AvailableFlowClasses from '../components/AvailableFlowClasses';
import * as Styles from '../styles/doc.module.scss';
import * as ContentStyle from '../styles/content.module.scss';
function DocTemplate({data, location, children}) {
  const post = data.mdx;
  return React.createElement(React.Fragment, null, React.createElement(Nav, {
    location: location
  }), React.createElement("div", {
    style: {
      padding: '40px'
    },
    className: Styles.DocWrapper
  }, React.createElement("div", {
    className: ContentStyle.SectionWrapper
  }, React.createElement("div", {
    className: ContentStyle.Section,
    style: {
      maxWidth: '900px'
    },
    role: "main"
  }, React.createElement(SEO, {
    description: post.frontmatter.description,
    title: post.frontmatter.title,
    slug: post.fields.slug,
    "data-category": post.frontmatter.category
  }), React.createElement(AvailableFlowClasses, {
    flowClasses: post?.frontmatter?.flowclass
  }), React.createElement("main", {
    id: "main",
    "data-category": post.frontmatter.category,
    "data-slug": post.fields.slug
  }, React.createElement(MDXProvider, null, children)), React.createElement(WasThisHelpful), React.createElement(Footer))), React.createElement(Aside, {
    tableOfContents: post.tableOfContents
  })));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DocTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query MDXPostBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      id
      body
      tableOfContents
      frontmatter {
        title
        description
        flowclass
        category
      }
      fields {
        slug
      }
      internal {
        contentFilePath
      }
    }
  }
`;
